import { IFilterRequest } from "../../repository/IFilterRequest";

export const getFilters = (categoryId?: string, filter?: IFilterRequest[], promoId?: string | number) => ({
  type: "@saga/GET_FILTERS",
  payload: { filter, categoryId, promoId },
});
